<template>
        <div class="warp">
            <!-- 面包屑 -->
            <breadcrumb :back="true" :crubList="[{name:'审核管理'},{name:'债权融资申请审核',goback:true},{name:'债权融资申请审核详情'}]" :title="'债权融资申请审核详情'"/>
            <!-- 主体内容 -->
            <!-- 用户明细 -->
            <div class="box">
               <el-card class="basic box_card" header="账号信息" shadow="never">
                 <el-row>
                  <el-col :span="8">
                    <div class="child">
                        <div class="name">账号：</div>
                            <div class="content">{{detail.user.userName || ''}}</div>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                        <div class="name">账号类型：</div>
                        <div class="content">{{detail.user.userTypeName}}</div>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                        <div class="name">姓名：</div>
                        <div class="content">{{detail.user.realName}}</div>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                        <div class="name">邮箱：</div>
                        <div class="content">{{detail.user.email}}</div>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                        <div class="name">联系地址：</div>
                        <div class="content">{{detail.user.contactAddress}}</div>
                    </div>
                  </el-col>
                  
                </el-row>
              </el-card>
              <el-card class="basic box_card mt16" header="提交信息" shadow="never">
                 <el-row>
                  <el-col :span="8">
                    <div class="child">
                        <div class="name">申请人姓名：</div>
                        <div class="content">{{detail.applicant}}</div>
                    </div>  
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                        <div class="name">联系手机号：</div>
                        <div class="content">{{detail.contactPhone}}</div>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                        <div class="name">公司全称：</div>
                        <div class="content">{{detail.applyCompany}}</div>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                        <div class="name">说明：</div>
                        <div class="content">{{detail.applyRemark}}</div>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                        <div class="name">附件：</div>
                        <ul class="content">
                                <li v-for="(item,index) in detail.fileList" :key="index"><span>{{item.fileName}}</span><i class="el-icon-download" @click="downLoad(item)"></i></li>
                            </ul>
                    </div>
                  </el-col>
                  <el-col :span="8">
                   <div class="child">
                            <div class="name">提交时间：</div>
                            <div class="content">{{detail.createTime}}</div>
                        </div>
                  </el-col>
                  
                </el-row>
              </el-card>
              <el-card class="basic box_card mt16" header="审核结果" shadow="never" v-if="tab==='2'">
                <el-row>
                    <el-col :span="8">
                      <div class="child">
                              <div class="name">审核结果：</div>
                              <div class="content">{{detail.checkStatusValue}}</div>
                          </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="child">
                            <div class="name">审核人：</div>
                            <div class="content">{{detail.modifyUserName}}</div>
                        </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="child">
                            <div class="name">审核时间：</div>
                            <div class="content">{{detail.checkTime}}</div>
                        </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="child">
                            <div class="name">说明：</div>
                            <div class="content">{{detail.checkExplanation}}</div>
                        </div>
                    </el-col>
                  </el-row>
              </el-card>

              <el-card class="basic box_card mt16" header="放款进度信息" shadow="never" v-if="tab==='2' && detail.rate === 1">
                <el-row>
                    <el-col :span="8">
                      <div class="child">
                              <div class="name">贷款进度：</div>
                              <div class="content">{{detail.rateValue ||  ''}}</div>
                          </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="child">
                            <div class="name">放款金额：</div>
                            <div class="content">{{detail.amount ||  ''}}</div>
                        </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="child">
                            <div class="name">更新时间：</div>
                            <div class="content">{{detail.updateTime ||  ''}}</div>
                        </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="child">
                            <div class="name">说明：</div>
                            <div class="content">{{detail.dealWithRemark ||  ''}}</div>
                        </div>
                    </el-col>
                  </el-row>
              </el-card>
              
              <el-card class="basic box_card mt16" header="申请轨迹" shadow="never" v-if="tab==='2'">
                <el-timeline >
                    <el-timeline-item type="primary"
                      v-for="(activity, index) in activities" :key="index">
                    <div>
                      <div class="title">{{activity.debtProductName}}<span>{{activity.bankName}}</span></div>
                      <div class="tips">申请时间：{{activity.createTime}}</div>
                    </div>
                    <div class="mt10">
                      <div class="infos">审核结果：<span :class="activity.bankCheckStatus === 1?'green':activity.bankCheckStatus === -1?'red':'primary'">{{activity.bankCheckStatusValue}}</span></div>
                      <div class="tips">审核时间：{{activity.bankCheckTime}}</div>
                      <div class="tips">说明：{{activity.bankAuditDesc}}</div>
                    </div>
                    <div class="mt10" v-if="activity.rateValue">
                        <div class="infos">放款进度：<span :class="activity.rateValue === '放款成功'?'green':'red'">{{activity.rateValue}}</span></div>
                        <div class="tips">更新时间：{{activity.updateTime}}</div>
                        <div class="tips">说明：{{activity.dealWithRemark}}</div>
                      </div>
                    </el-timeline-item>
                  </el-timeline>
              </el-card>
              
            </div>
        </div>
</template>

<script>
import breadcrumb from '../../components/breadcrumb';
import {onDownload} from "@/utils/common";
export default {
    components:{
        breadcrumb
    },
    data(){
        return{
            tab:'1',//选项卡
            id:'',//详情id
            detail:{
               user:{
                    userName:'',
                    userTypeName:"",
                    realName:"",
                    email:"",
                    contactAddress:"",
                },
                applicant:"",
                contactPhone:"",
                applyCompany:"",
                applyRemark:"",
                fileList:[],
                createTime:"",
                checkStatusValue:"",
                modifyUserName:"",
                checkExplanation:""
            },//数据
            activities: []
 
        }
    },
    methods:{
        //下载附件
        downLoad:function({fileName,filePath}){
           const formData = new window.FormData()
          formData.append('fileName', filePath)
          onDownload(formData,fileName)
        },
        //获取数据
        async getData(){
         const {code,data,msg} = await this.$axiosc.get('backstage/apply/details/'+this.id)
          if (code == 200) {            
              this.detail = data;
          } else {
              this.$alert(msg)
          }
        },
        // 
        async getSetp(){
         const {code,data,msg} = await this.$axiosc.get('/backstage/apply/audited/track/'+this.id)
          if (code == 200) {            
              this.activities = data;
          } else {
              this.$alert(msg)
          }
        },
    },
    created(){
        this.tab=this.$route.params.type
        this.id=this.$route.query.id;
        if(this.id){
            this.getSetp()
            this.getData()
            
        }
    }
}
</script>

<style lang="scss" scoped>
.warp{
  height:100%;
  overflow: hidden;
}
.box{
    height: calc(100% - 40px);
    overflow-x: hidden;
    overflow-y: auto;
    // margin-top: 20px;
    &_card{
      border:none;
      &::v-deep{
        .el-card__header{
          font-size: 16px;
          color: #262626;
          padding:14px 22px !important;
          border-bottom-color:#E5E5E5;
        }
        .el-card__body{
          padding:24px 25px !important;
        }
      }
    }
}
.basic{
  color:$font;
  font-size: 14px;
  font-weight: 400;
  line-height: 40px;
  // background: #fff;
  .el-col{
    margin: 10px 0;
  }
  .child{
    color:#595959;
  }
}
.main{
  background: transparent !important;
  padding:0 !important;
}
.title{
    font-size: 16px;
    font-weight: bold;
    margin-bottom:8px;
    span{
        font-size: 14px;
        font-weight: normal;
        margin-left:10px;
        color:#666;
    }
}
.tips{
    font-size: 12px;
    color:#999;
    line-height:20px;
}
.infos{
    font-size: 14px;
    font-weight: 400;
    margin-bottom:5px;
}
.red{
    color:red;
}
.green{
    color:green
}
.primary{
    color:#1069DD
}
::v-deep .el-timeline-item__node--primary {
    width:8px;
    height: 8px;
    background:#fff;
    border:2px solid #1069DD;
  }
</style>